import React from "react";
import Modal from "react-modal";
import { useState } from "react";
import "./gallery.css";

function ImageModal(props) {
  let subtitle;

  const { modalImagePath } = props;

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px",
    },
  };

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <Modal
      isOpen={props.isOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={props.closeModal}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <img
        className="gallery_image_modal"
        src={`https://skylark-website-images.s3.ap-south-1.amazonaws.com/event-images/${modalImagePath}`}
      />
    </Modal>
  );
}

export default ImageModal;
